import React from "react";
import NavBar from "../NavBar";
import Footer from "../Footer";

function TermsOfService() {
  return (
    <div style={{ marginTop: "7rem" }}>
      {/*Add title and metadata */}
      <title>Terms of use</title>
      <meta name="robots" content="noindex"></meta>

      {/*navbar*/}
      <NavBar />

      {/* Privacy Policy Content */}
      <div className="container">
        {/* Privacy Policy Content */}
        <div className="p-3">
          <h1 className="display-4">Terms of Service</h1>
          <h6 className="mt-3">Last updated July 09, 2025</h6>
          <h4 className="mt-4">AGREEMENT TO OUR LEGAL TERMS</h4>
          <p className="lead mt-3">
            We are TextHumanizer (<b>'Company'</b>, <b>'we'</b>, <b>'us'</b>, or{" "}
            <b>'our'</b>), a company registered in India We operate the website
            https://www.humanizetexts.com (the <b>'Site'</b>), as well as any
            other related products and services that refer or link to these
            legal terms (the <b>'Legal Terms'</b>) (collectively, the{" "}
            <b>'Services'</b>). You can contact us by email at
            racersoft@gmail.com. These Legal Terms constitute a legally binding
            agreement made between you, whether personally or on behalf of an
            entity (<b>'you'</b>), and RacerSoft, concerning your access to and
            use of the Services. You agree that by accessing the Services, you
            have read, understood, and agreed to be bound by all of these Legal
            Terms. IF YOU DO NOT AGREE WITH ALL OF THESE LEGAL TERMS, THEN YOU
            ARE EXPRESSLY PROHIBITED FROM USING THE SERVICES AND YOU MUST
            DISCONTINUE USE IMMEDIATELY. Supplemental terms and conditions or
            documents that may be posted on the Services from time to time are
            hereby expressly incorporated herein by reference. We reserve the
            right, in our sole discretion, to make changes or modifications to
            these Legal Terms from time to time. We will alert you about any
            changes by updating the 'Last updated' date of these Legal Terms,
            and you waive any right to receive specific notice of each such
            change. It is your responsibility to periodically review these Legal
            Terms to stay informed of updates. You will be subject to, and will
            be deemed to have been made aware of and to have accepted, the
            changes in any revised Legal Terms by your continued use of the
            Services after the date such revised Legal Terms are posted. The
            Services are intended for users who are at least 18 years old.
            Persons under the age of 18 are not permitted to use or register for
            the Services. We recommend that you print a copy of these Legal
            Terms for your records.
          </p>
          <h4 className="mt-4">TABLE OF CONTENTS</h4>
          <ol>
            <li>
              <a href="#our_services">OUR SERVICES</a>
            </li>
            <li>
              <a href="#intellectual_property">INTELLECTUAL PROPERTY RIGHTS</a>
            </li>
            <li>
              <a href="#user_representation">USER REPRESENTATIONS</a>
            </li>
            <li>
              <a href="#user_registration">USER REGISTRATION</a>
            </li>
            <li>
              <a href="#purchases_and_payments">PURCHASES AND PAYMENT</a>
            </li>
            <li>
              <a href="#subscriptions">SUBSCRIPTIONS</a>
            </li>
            <li>
              <a href="#prohibited_activity">PROHIBITED ACTIVITIES</a>
            </li>
            <li>
              <a href="#user_generated_contribution">
                USER GENERATED CONTRIBUTIONS
              </a>
            </li>
            <li>
              <a href="#contribution_licence">CONTRIBUTION LICENCE</a>
            </li>
            <li>
              <a href="#social_media">SOCIAL MEDIA</a>
            </li>
            <li>
              <a href="#advertisers">ADVERTISERS</a>
            </li>
            <li>
              <a href="#services_management">SERVICES MANAGEMENT</a>
            </li>
            <li>
              <a href="#privacy_policy">PRIVACY POLICY</a>
            </li>
            <li>
              <a href="#terms_and_termination">TERM AND TERMINATION</a>
            </li>
            <li>
              <a href="#modificationsa_and_interruptions">
                MODIFICATIONS AND INTERRUPTIONS
              </a>
            </li>
            <li>
              <a href="#governing_law">GOVERNING LAW</a>
            </li>
            <li>
              <a href="#dispute_resolution">DISPUTE RESOLUTION</a>
            </li>
            <li>
              <a href="#corrections">CORRECTIONS</a>
            </li>
            <li>
              <a href="#disclaimer">DISCLAIMER</a>
            </li>
            <li>
              <a href="#limitations_of_liability">LIMITATIONS OF LIABILITY</a>
            </li>
            <li>
              <a href="#indemnification">INDEMNIFICATION</a>
            </li>
            <li>
              <a href="#user_data">USER DATA</a>
            </li>
            <li>
              <a href="#electronic_communications">
                ELECTRONIC COMMUNICATIONS, TRANSACTIONS, AND SIGNATURES
              </a>
            </li>
            <li>
              <a href="#california_user_and_residents">
                CALIFORNIA USERS AND RESIDENTS
              </a>
            </li>
            <li>
              <a href="#miscellaneous">MISCELLANEOUS</a>
            </li>
            <li>
              <a href="#contact_us">CONTACT US</a>
            </li>
          </ol>
          <h4 className="mt-4" id="our_services">
            1. OUR SERVICES
          </h4>
          <p className="lead mt-3">
            The information provided when using the Services is not intended for
            distribution to or use by any person or entity in any jurisdiction
            or country where such distribution or use would be contrary to law
            or regulation or which would subject us to any registration
            requirement within such jurisdiction or country. Accordingly, those
            persons who choose to access the Services from other locations do so
            on their own initiative and are solely responsible for compliance
            with local laws, if and to the extent local laws are applicable.
          </p>
          <p className="lead mt-3">
            The Services are not tailored to comply with industry-specific
            regulations (Health Insurance Portability and Accountability Act
            (HIPAA), Federal Information Security Management Act (FISMA), etc.),
            so if your interactions would be subjected to such laws, you may not
            use the Services. You may not use the Services in a way that would
            violate the Gramm-Leach-Bliley Act (GLBA).
          </p>
          <h4 className="mt-4" id="intellectual_property">
            2. INTELLECTUAL PROPERTY RIGHTS
          </h4>
          <p className="lead mt-4">
            <b>Our intellectual property</b>
            <br />
            <br />
            We are the owner or the licensee of all intellectual property rights
            in our Services, including all source code, databases,
            functionality, software, website designs, audio, video, text,
            photographs, and graphics in the Services (collectively, the
            'Content'), as well as the trademarks, service marks, and logos
            contained therein (the 'Marks'). Our Content and Marks are protected
            by copyright and trademark laws (and various other intellectual
            property rights and unfair competition laws) and treaties in the
            United States and around the world. The Content and Marks are
            provided in or through the Services 'AS IS' for your personal,
            non-commercial use only.
            <b>Your use of our Services</b>
            <br />
            <br />
            Subject to your compliance with these Legal Terms, including the
            'PROHIBITED ACTIVITIES' section below, we grant you a non-exclusive,
            non-transferable, revocable licence to: access the Services; and
            download or print a copy of any portion of the Content to which you
            have properly gained access, solely for your personal,
            non-commercial use. Except as set out in this section or elsewhere
            in our Legal Terms, no part of the Services and no Content or Marks
            may be copied, reproduced, aggregated, republished, uploaded,
            posted, publicly displayed, encoded, translated, transmitted,
            distributed, sold, licensed, or otherwise exploited for any
            commercial purpose whatsoever, without our express prior written
            permission. If you wish to make any use of the Services, Content, or
            Marks other than as set out in this section or elsewhere in our
            Legal Terms, please address your request to: racersoft@gmail.com. If
            we ever grant you the permission to post, reproduce, or publicly
            display any part of our Services or Content, you must identify us as
            the owners or licensors of the Services, Content, or Marks and
            ensure that any copyright or proprietary notice appears or is
            visible on posting, reproducing, or displaying our Content. We
            reserve all rights not expressly granted to you in and to the
            Services, Content, and Marks. Any breach of these Intellectual
            Property Rights will constitute a material breach of our Legal Terms
            and your right to use our Services will terminate immediately.
            <br />
            <br />
            <b>Your submissions</b>
            <br />
            <br />
            Please review this section and the 'PROHIBITED ACTIVITIES' section
            carefully prior to using our Services to understand the (a) rights
            you give us and (b) obligations you have when you post or upload any
            content through the Services.
            <br />
            <br />
            <b>Submissions:</b> <br />
            <br />
            By directly sending us any question, comment, suggestion, idea,
            feedback, or other information about the Services ('Submissions'),
            you agree to assign to us all intellectual property rights in such
            Submission. You agree that we shall own this Submission and be
            entitled to its unrestricted use and dissemination for any lawful
            purpose, commercial or otherwise, without acknowledgment or
            compensation to you.
          </p>
          <p className="lead mt-4">
            <b>You are responsible for what you post or upload:</b> By sending
            us Submissions through any part of the Services you: confirm that
            you have read and agree with our{" "}
            <a href="#prohibited_activity">'PROHIBITED ACTIVITIES'</a> and will
            not post, send, publish, upload, or transmit through the Services
            any Submission that is illegal, harassing, hateful, harmful,
            defamatory, obscene, bullying, abusive, discriminatory, threatening
            to any person or group, sexually explicit, false, inaccurate,
            deceitful, or misleading; to the extent permissible by applicable
            law, waive any and all moral rights to any such Submission; warrant
            that any such Submission are original to you or that you have the
            necessary rights and licences to submit such Submissions and that
            you have full authority to grant us the above-mentioned rights in
            relation to your Submissions; and warrant and represent that your
            Submissions do not constitute confidential information. You are
            solely responsible for your Submissions and you expressly agree to
            reimburse us for any and all losses that we may suffer because of
            your breach of (a) this section, (b) any third party’s intellectual
            property rights, or (c) applicable law.
          </p>
          <h4 className="mt-4" id="user_representation">
            3. USER REPRESENTATIONS
          </h4>
          <p className="lead mt-4">
            By using the Services, you represent and warrant that: (1) all
            registration information you submit will be true, accurate, current,
            and complete; (2) you will maintain the accuracy of such information
            and promptly update such registration information as necessary; (3)
            you have the legal capacity and you agree to comply with these Legal
            Terms; (4) you are not a minor in the jurisdiction in which you
            reside; (5) you will not access the Services through automated or
            non-human means, whether through a bot, script or otherwise; (6) you
            will not use the Services for any illegal or unauthorised purpose;
            and (7) your use of the Services will not violate any applicable law
            or regulation. If you provide any information that is untrue,
            inaccurate, not current, or incomplete, we have the right to suspend
            or terminate your account and refuse any and all current or future
            use of the Services (or any portion thereof).
          </p>
          <h4 className="mt-4" id="user_registration">
            4. USER REGISTRATION
          </h4>
          <p className="lead mt-4">
            You may be required to register to use the Services. You agree to
            keep your password confidential and will be responsible for all use
            of your account and password. We reserve the right to remove,
            reclaim, or change a username you select if we determine, in our
            sole discretion, that such username is inappropriate, obscene, or
            otherwise objectionable.
          </p>
          <h4 className="mt-4" id="purchases_and_payments">
            5. PURCHASES AND PAYMENT
          </h4>
          <p className="lead mt-4">
            We accept the following forms of payment:
            <br />
            - Visa
            <br />
            - Mastercard
            <br />
            - American Express
            <br />
            - Discover
            <br />
            - PayPal
            <br />
            <br />
            You agree to provide current, complete, and accurate purchase and
            account information for all purchases made via the Services. You
            further agree to promptly update account and payment information,
            including email address, payment method, and payment card expiration
            date, so that we can complete your transactions and contact you as
            needed. Sales tax will be added to the price of purchases as deemed
            required by us. We may change prices at any time. All payments shall
            be in US dollars.
            <br />
            <br />
            You agree to pay all charges at the prices then in effect for your
            purchases and any applicable shipping fees, and you authorise us to
            charge your chosen payment provider for any such amounts upon
            placing your order. We reserve the right to correct any errors or
            mistakes in pricing, even if we have already requested or received
            payment.
            <br />
            <br />
            We reserve the right to refuse any order placed through the
            Services. We may, in our sole discretion, limit or cancel quantities
            purchased per person, per household, or per order. These
            restrictions may include orders placed by or under the same customer
            account, the same payment method, and/or orders that use the same
            billing or shipping address. We reserve the right to limit or
            prohibit orders that, in our sole judgement, appear to be placed by
            dealers, resellers, or distributors.
          </p>
          <h4 className="mt-4" id="subscriptions">
            6. SUBSCRIPTIONS
          </h4>
          <p className="lead mt-4">
            <b>Billing and Renewal</b>
            <br />
            <br />
            Your subscription will continue and automatically renew unless
            cancelled. You consent to our charging your payment method on a
            recurring basis without requiring your prior approval for each
            recurring charge, until such time as you cancel the applicable
            order. The length of your billing cycle will depend on the type of
            subscription plan you choose when you subscribed to the Services.
            <br />
            <br />
            <b>Free Trial</b>
            <br />
            <br />
            We offer a 30-day free trial to new users who register with the
            Services. The account will be charged according to the user's chosen
            subscription at the end of the free trial.
            <br />
            <br />
            <b>Cancellation</b>
            <br />
            <br />
            All purchases are non-refundable. You can cancel your subscription
            at any time by logging into your account. Your cancellation will
            take effect at the end of the current paid term. If you have any
            questions or are unsatisfied with our Services, please email us at
            racersoft@gmail.com.
            <br />
            <br />
            <b>Fee Changes</b>
            <br />
            <br />
            We may, from time to time, make changes to the subscription fee and
            will communicate any price changes to you in accordance with
            applicable law.
          </p>
          <h4 className="mt-4" id="prohibited_activity">
            7. PROHIBITED ACTIVITIES
          </h4>
          <p className="lead mt-4">
            You may not access or use the Services for any purpose other than
            that for which we make the Services available. The Services may not
            be used in connection with any commercial endeavours except those
            that are specifically endorsed or approved by us.
            <br />
            <br />
            As a user of the Services, you agree not to:
            <br />
            <br />
            <ul>
              <li>
                Systematically retrieve data or other content from the Services
                to create or compile, directly or indirectly, a collection,
                compilation, database, or directory without written permission
                from us.
              </li>
              <li>
                Trick, defraud, or mislead us and other users, especially in any
                attempt to learn sensitive account information such as user
                passwords.
              </li>
              <li>
                Circumvent, disable, or otherwise interfere with
                security-related features of the Services, including features
                that prevent or restrict the use or copying of any Content or
                enforce limitations on the use of the Services and/or the
                Content contained therein.
              </li>
              <li>
                Disparage, tarnish, or otherwise harm, in our opinion, us and/or
                the Services.
              </li>
              <li>
                Use any information obtained from the Services in order to
                harass, abuse, or harm another person.
              </li>
              <li>
                Make improper use of our support services or submit false
                reports of abuse or misconduct.
              </li>
              <li>
                Use the Services in a manner inconsistent with any applicable
                laws or regulations.
              </li>
              <li>
                Engage in unauthorised framing of or linking to the Services.
              </li>
              <li>
                Upload or transmit (or attempt to upload or to transmit)
                viruses, Trojan horses, or other material, including excessive
                use of capital letters and spamming (continuous posting of
                repetitive text), that interferes with any party’s uninterrupted
                use and enjoyment of the Services or modifies, impairs,
                disrupts, alters, or interferes with the use, features,
                functions, operation, or maintenance of the Services.
              </li>
              <li>
                Engage in any automated use of the system, such as using scripts
                to send comments or messages, or using any data mining, robots,
                or similar data gathering and extraction tools.
              </li>
              <li>
                Delete the copyright or other proprietary rights notice from any
                Content.
              </li>
              <li>
                Attempt to impersonate another user or person or use the
                username of another user.
              </li>
              <li>
                Upload or transmit (or attempt to upload or to transmit) any
                material that acts as a passive or active information collection
                or transmission mechanism, including without limitation, clear
                graphics interchange formats ('gifs'), 1×1 pixels, web bugs,
                cookies, or other similar devices (sometimes referred to as
                'spyware' or 'passive collection mechanisms' or 'pcms').
              </li>
              <li>
                Interfere with, disrupt, or create an undue burden on the
                Services or the networks or services connected to the Services.
              </li>
              <li>
                Harass, annoy, intimidate, or threaten any of our employees or
                agents engaged in providing any portion of the Services to you.
              </li>
              <li>
                Attempt to bypass any measures of the Services designed to
                prevent or restrict access to the Services, or any portion of
                the Services.
              </li>
              <li>
                Copy or adapt the Services' software, including but not limited
                to Flash, PHP, HTML, JavaScript, or other code.
              </li>
              <li>
                Except as permitted by applicable law, decipher, decompile,
                disassemble, or reverse engineer any of the software comprising
                or in any way making up a part of the Services.
              </li>
              <li>
                Except as may be the result of standard search engine or
                Internet browser usage, use, launch, develop, or distribute any
                automated system, including without limitation, any spider,
                robot, cheat utility, scraper, or offline reader that accesses
                the Services, or use or launch any unauthorised script or other
                software.
              </li>
              <li>
                Use a buying agent or purchasing agent to make purchases on the
                Services.
              </li>
              <li>
                Make any unauthorised use of the Services, including collecting
                usernames and/or email addresses of users by electronic or other
                means for the purpose of sending unsolicited email, or creating
                user accounts by automated means or under false pretences.
              </li>
              <li>
                Use the Services as part of any effort to compete with us or
                otherwise use the Services and/or the Content for any
                revenue-generating endeavour or commercial enterprise.
              </li>
            </ul>
          </p>
          <h4 className="mt-4" id="user_generated_contribution">
            8. USER GENERATED CONTRIBUTIONS
          </h4>
          <p className="lead mt-4">
            The Services does not offer users to submit or post content. We may
            provide you with the opportunity to create, submit, post, display,
            transmit, perform, publish, distribute, or broadcast content and
            materials to us or on the Services, including but not limited to
            text, writings, video, audio, photographs, graphics, comments,
            suggestions, or personal information or other material
            (collectively, 'Contributions'). Contributions may be viewable by
            other users of the Services and through third-party websites. As
            such, any Contributions you transmit may be treated in accordance
            with the Services' Privacy Policy. When you create or make available
            any Contributions, you thereby represent and warrant that:
            <br />
            <br />
            <ul>
              <li>
                The creation, distribution, transmission, public display, or
                performance, and the accessing, downloading, or copying of your
                Contributions do not and will not infringe the proprietary
                rights, including but not limited to the copyright, patent,
                trademark, trade secret, or moral rights of any third party.
              </li>
              <li>
                You are the creator and owner of or have the necessary licences,
                rights, consents, releases, and permissions to use and to
                authorise us, the Services, and other users of the Services to
                use your Contributions in any manner contemplated by the
                Services and these Legal Terms.
              </li>
              <li>
                You have the written consent, release, and/or permission of each
                and every identifiable individual person in your Contributions
                to use the name or likeness of each and every such identifiable
                individual person to enable inclusion and use of your
                Contributions in any manner contemplated by the Services and
                these Legal Terms.
              </li>
              <li>
                Your Contributions are not false, inaccurate, or misleading.{" "}
              </li>
              <li>
                Your Contributions are not unsolicited or unauthorised
                advertising, promotional materials, pyramid schemes, chain
                letters, spam, mass mailings, or other forms of solicitation.
              </li>
              <li>
                Your Contributions are not obscene, lewd, lascivious, filthy,
                violent, harassing, libellous, slanderous, or otherwise
                objectionable (as determined by us).
              </li>
              <li>
                Your Contributions do not ridicule, mock, disparage, intimidate,
                or abuse anyone.
              </li>
              <li>
                Your Contributions are not used to harass or threaten (in the
                legal sense of those terms) any other person and to promote
                violence against a specific person or class of people.
              </li>
              <li>
                Your Contributions do not violate any applicable law,
                regulation, or rule.{" "}
              </li>
              <li>
                Your Contributions do not violate the privacy or publicity
                rights of any third party.
              </li>
              <li>
                Your Contributions do not violate any applicable law concerning
                child pornography, or otherwise intended to protect the health
                or well-being of minors.
              </li>
              <li>
                Your Contributions do not include any offensive comments that
                are connected to race, national origin, gender, sexual
                preference, or physical handicap.
              </li>
              <li>
                Your Contributions do not otherwise violate, or link to material
                that violates, any provision of these Legal Terms, or any
                applicable law or regulation.
              </li>
            </ul>
            Any use of the Services in violation of the foregoing violates these
            Legal Terms and may result in, among other things, termination or
            suspension of your rights to use the Services.
          </p>
          <h4 className="mt-4" id="contribution_licence">
            9. CONTRIBUTION LICENCE
          </h4>
          <p className="lead mt-4">
            You and Services agree that we may access, store, process, and use
            any information and personal data that you provide following the
            terms of the Privacy Policy and your choices (including settings).
            <br />
            <br />
            By submitting suggestions or other feedback regarding the Services,
            you agree that we can use and share such feedback for any purpose
            without compensation to you.
            <br />
            <br />
            We do not assert any ownership over your Contributions. You retain
            full ownership of all of your Contributions and any intellectual
            property rights or other proprietary rights associated with your
            Contributions. We are not liable for any statements or
            representations in your Contributions provided by you in any area on
            the Services. You are solely responsible for your Contributions to
            the Services and you expressly agree to exonerate us from any and
            all responsibility and to refrain from any legal action against us
            regarding your Contributions.
          </p>
          <h4 className="mt-4" id="social_media">
            10. SOCIAL MEDIA
          </h4>
          <p className="lead mt-4">
            As part of the functionality of the Services, you may link your
            account with online accounts you have with third-party service
            providers (each such account, a 'Third-Party Account') by either:
            (1) providing your Third-Party Account login information through the
            Services; or (2) allowing us to access your Third-Party Account, as
            is permitted under the applicable terms and conditions that govern
            your use of each Third-Party Account. You represent and warrant that
            you are entitled to disclose your Third-Party Account login
            information to us and/or grant us access to your Third-Party
            Account, without breach by you of any of the terms and conditions
            that govern your use of the applicable Third-Party Account, and
            without obligating us to pay any fees or making us subject to any
            usage limitations imposed by the third-party service provider of the
            Third-Party Account. By granting us access to any Third-Party
            Accounts, you understand that (1) we may access, make available, and
            store (if applicable) any content that you have provided to and
            stored in your Third-Party Account (the 'Social Network Content') so
            that it is available on and through the Services via your account,
            including without limitation any friend lists and (2) we may submit
            to and receive from your Third-Party Account additional information
            to the extent you are notified when you link your account with the
            Third-Party Account. Depending on the Third-Party Accounts you
            choose and subject to the privacy settings that you have set in such
            Third-Party Accounts, personally identifiable information that you
            post to your Third-Party Accounts may be available on and through
            your account on the Services. Please note that if a Third-Party
            Account or associated service becomes unavailable or our access to
            such Third-Party Account is terminated by the third-party service
            provider, then Social Network Content may no longer be available on
            and through the Services. You will have the ability to disable the
            connection between your account on the Services and your Third-Party
            Accounts at any time. PLEASE NOTE THAT YOUR RELATIONSHIP WITH THE
            THIRD-PARTY SERVICE PROVIDERS ASSOCIATED WITH YOUR THIRD-PARTY
            ACCOUNTS IS GOVERNED SOLELY BY YOUR AGREEMENT(S) WITH SUCH
            THIRD-PARTY SERVICE PROVIDERS. We make no effort to review any
            Social Network Content for any purpose, including but not limited
            to, for accuracy, legality, or non-infringement, and we are not
            responsible for any Social Network Content. You acknowledge and
            agree that we may access your email address book associated with a
            Third-Party Account and your contacts list stored on your mobile
            device or tablet computer solely for purposes of identifying and
            informing you of those contacts who have also registered to use the
            Services. You can deactivate the connection between the Services and
            your Third-Party Account by contacting us using the contact
            information below or through your account settings (if applicable).
            We will attempt to delete any information stored on our servers that
            was obtained through such Third-Party Account, except the username
            and profile picture that become associated with your account.
          </p>
          <h4 className="mt-4" id="advertisers">
            11. ADVERTISERS
          </h4>
          <p className="lead mt-4">
            We allow advertisers to display their advertisements and other
            information in certain areas of the Services, such as sidebar
            advertisements or banner advertisements. We simply provide the space
            to place such advertisements, and we have no other relationship with
            advertisers.
          </p>
          <h4 className="mt-4" id="services_management">
            12. SERVICES MANAGEMENT
          </h4>
          <p className="lead mt-4">
            We reserve the right, but not the obligation, to: (1) monitor the
            Services for violations of these Legal Terms; (2) take appropriate
            legal action against anyone who, in our sole discretion, violates
            the law or these Legal Terms, including without limitation,
            reporting such user to law enforcement authorities; (3) in our sole
            discretion and without limitation, refuse, restrict access to, limit
            the availability of, or disable (to the extent technologically
            feasible) any of your Contributions or any portion thereof; (4) in
            our sole discretion and without limitation, notice, or liability, to
            remove from the Services or otherwise disable all files and content
            that are excessive in size or are in any way burdensome to our
            systems; and (5) otherwise manage the Services in a manner designed
            to protect our rights and property and to facilitate the proper
            functioning of the Services.
          </p>
          <h4 className="mt-4" id="privacy_policy">
            13. PRIVACY POLICY
          </h4>
          <p className="lead mt-4">
            We care about data privacy and security. Please review our{" "}
            <a href="http://www.humanizetexts.com/privacy-policy">
              Privacy Policy
            </a>
            . By using the Services, you agree to be bound by our Privacy
            Policy, which is incorporated into these Legal Terms. Please be
            advised the Services are hosted in India. If you access the Services
            from any other region of the world with laws or other requirements
            governing personal data collection, use, or disclosure that differ
            from applicable laws in India, then through your continued use of
            the Services, you are transferring your data to India, and you
            expressly consent to have your data transferred to and processed in
            India.
          </p>
          <h4 className="mt-4" id="terms_and_termination">
            14. TERM AND TERMINATION
          </h4>
          <p className="lead mt-4">
            These Legal Terms shall remain in full force and effect while you
            use the Services. WITHOUT LIMITING ANY OTHER PROVISION OF THESE
            LEGAL TERMS, WE RESERVE THE RIGHT TO, IN OUR SOLE DISCRETION AND
            WITHOUT NOTICE OR LIABILITY, DENY ACCESS TO AND USE OF THE SERVICES
            (INCLUDING BLOCKING CERTAIN IP ADDRESSES), TO ANY PERSON FOR ANY
            REASON OR FOR NO REASON, INCLUDING WITHOUT LIMITATION FOR BREACH OF
            ANY REPRESENTATION, WARRANTY, OR COVENANT CONTAINED IN THESE LEGAL
            TERMS OR OF ANY APPLICABLE LAW OR REGULATION. WE MAY TERMINATE YOUR
            USE OR PARTICIPATION IN THE SERVICES OR DELETE YOUR ACCOUNT AND ANY
            CONTENT OR INFORMATION THAT YOU POSTED AT ANY TIME, WITHOUT WARNING,
            IN OUR SOLE DISCRETION.
            <br />
            <br />
            If we terminate or suspend your account for any reason, you are
            prohibited from registering and creating a new account under your
            name, a fake or borrowed name, or the name of any third party, even
            if you may be acting on behalf of the third party. In addition to
            terminating or suspending your account, we reserve the right to take
            appropriate legal action, including without limitation pursuing
            civil, criminal, and injunctive redress.
          </p>
          <h4 className="mt-4" id="modificationsa_and_interruptions">
            15. MODIFICATIONS AND INTERRUPTIONS
          </h4>
          <p className="lead mt-4">
            We reserve the right to change, modify, or remove the contents of
            the Services at any time or for any reason at our sole discretion
            without notice. However, we have no obligation to update any
            information on our Services. We will not be liable to you or any
            third party for any modification, price change, suspension, or
            discontinuance of the Services.
            <br />
            <br />
            We cannot guarantee the Services will be available at all times. We
            may experience hardware, software, or other problems or need to
            perform maintenance related to the Services, resulting in
            interruptions, delays, or errors. We reserve the right to change,
            revise, update, suspend, discontinue, or otherwise modify the
            Services at any time or for any reason without notice to you. You
            agree that we have no liability whatsoever for any loss, damage, or
            inconvenience caused by your inability to access or use the Services
            during any downtime or discontinuance of the Services. Nothing in
            these Legal Terms will be construed to obligate us to maintain and
            support the Services or to supply any corrections, updates, or
            releases in connection therewith.
          </p>
          <h4 className="mt-4" id="governing_law">
            16. GOVERNING LAW
          </h4>
          <p className="lead mt-4">
            These Legal Terms shall be governed by and defined following the
            laws of __________. RacerSoft and yourself irrevocably consent that
            the courts of __________ shall have exclusive jurisdiction to
            resolve any dispute which may arise in connection with these Legal
            Terms.
          </p>
          <h4 className="mt-4" id="dispute_resolution">
            17. DISPUTE RESOLUTION
          </h4>
          <p className="lead mt-4">
            <b>Binding Arbitration</b>
            <br />
            <br />
            Any dispute arising out of or in connection with these Legal Terms,
            including any question regarding its existence, validity, or
            termination, shall be referred to and finally resolved by the
            International Commercial Arbitration Court under the European
            Arbitration Chamber (Belgium, Brussels, Avenue Louise, 146)
            according to the Rules of this ICAC, which, as a result of referring
            to it, is considered as the part of this clause. The number of
            arbitrators shall be __________. The seat, or legal place, or
            arbitration shall be __________. The language of the proceedings
            shall be __________. The governing law of these Legal Terms shall be
            substantive law of __________.
            <br />
            <br />
            <b>Restrictions</b>
            <br />
            <br />
            The Parties agree that any arbitration shall be limited to the
            Dispute between the Parties individually. To the full extent
            permitted by law, (a) no arbitration shall be joined with any other
            proceeding; (b) there is no right or authority for any Dispute to be
            arbitrated on a class-action basis or to utilise class action
            procedures; and (c) there is no right or authority for any Dispute
            to be brought in a purported representative capacity on behalf of
            the general public or any other persons.
            <br />
            <br />
            <b>Exceptions to Arbitration</b>
            <br />
            <br />
            The Parties agree that the following Disputes are not subject to the
            above provisions concerning binding arbitration: (a) any Disputes
            seeking to enforce or protect, or concerning the validity of, any of
            the intellectual property rights of a Party; (b) any Dispute related
            to, or arising from, allegations of theft, piracy, invasion of
            privacy, or unauthorised use; and (c) any claim for injunctive
            relief. If this provision is found to be illegal or unenforceable,
            then neither Party will elect to arbitrate any Dispute falling
            within that portion of this provision found to be illegal or
            unenforceable and such Dispute shall be decided by a court of
            competent jurisdiction within the courts listed for jurisdiction
            above, and the Parties agree to submit to the personal jurisdiction
            of that court.
          </p>
          <h4 className="mt-4" id="corrections">
            18. CORRECTIONS
          </h4>
          <p className="lead mt-4">
            There may be information on the Services that contains typographical
            errors, inaccuracies, or omissions, including descriptions, pricing,
            availability, and various other information. We reserve the right to
            correct any errors, inaccuracies, or omissions and to change or
            update the information on the Services at any time, without prior
            notice.
          </p>
          <h4 className="mt-4" id="disclaimer">
            19. DISCLAIMER
          </h4>
          <p className="lead mt-4">
            THE SERVICES ARE PROVIDED ON AN AS-IS AND AS-AVAILABLE BASIS. YOU
            AGREE THAT YOUR USE OF THE SERVICES WILL BE AT YOUR SOLE RISK. TO
            THE FULLEST EXTENT PERMITTED BY LAW, WE DISCLAIM ALL WARRANTIES,
            EXPRESS OR IMPLIED, IN CONNECTION WITH THE SERVICES AND YOUR USE
            THEREOF, INCLUDING, WITHOUT LIMITATION, THE IMPLIED WARRANTIES OF
            MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE, AND
            NON-INFRINGEMENT. WE MAKE NO WARRANTIES OR REPRESENTATIONS ABOUT THE
            ACCURACY OR COMPLETENESS OF THE SERVICES' CONTENT OR THE CONTENT OF
            ANY WEBSITES OR MOBILE APPLICATIONS LINKED TO THE SERVICES AND WE
            WILL ASSUME NO LIABILITY OR RESPONSIBILITY FOR ANY (1) ERRORS,
            MISTAKES, OR INACCURACIES OF CONTENT AND MATERIALS, (2) PERSONAL
            INJURY OR PROPERTY DAMAGE, OF ANY NATURE WHATSOEVER, RESULTING FROM
            YOUR ACCESS TO AND USE OF THE SERVICES, (3) ANY UNAUTHORISED ACCESS
            TO OR USE OF OUR SECURE SERVERS AND/OR ANY AND ALL PERSONAL
            INFORMATION AND/OR FINANCIAL INFORMATION STORED THEREIN, (4) ANY
            INTERRUPTION OR CESSATION OF TRANSMISSION TO OR FROM THE SERVICES,
            (5) ANY BUGS, VIRUSES, TROJAN HORSES, OR THE LIKE WHICH MAY BE
            TRANSMITTED TO OR THROUGH THE SERVICES BY ANY THIRD PARTY, AND/OR
            (6) ANY ERRORS OR OMISSIONS IN ANY CONTENT AND MATERIALS OR FOR ANY
            LOSS OR DAMAGE OF ANY KIND INCURRED AS A RESULT OF THE USE OF ANY
            CONTENT POSTED, TRANSMITTED, OR OTHERWISE MADE AVAILABLE VIA THE
            SERVICES. WE DO NOT WARRANT, ENDORSE, GUARANTEE, OR ASSUME
            RESPONSIBILITY FOR ANY PRODUCT OR SERVICE ADVERTISED OR OFFERED BY A
            THIRD PARTY THROUGH THE SERVICES, ANY HYPERLINKED WEBSITE, OR ANY
            WEBSITE OR MOBILE APPLICATION FEATURED IN ANY BANNER OR OTHER
            ADVERTISING, AND WE WILL NOT BE A PARTY TO OR IN ANY WAY BE
            RESPONSIBLE FOR MONITORING ANY TRANSACTION BETWEEN YOU AND ANY
            THIRD-PARTY PROVIDERS OF PRODUCTS OR SERVICES. AS WITH THE PURCHASE
            OF A PRODUCT OR SERVICE THROUGH ANY MEDIUM OR IN ANY ENVIRONMENT,
            YOU SHOULD USE YOUR BEST JUDGEMENT AND EXERCISE CAUTION WHERE
            APPROPRIATE.
          </p>
          <h4 className="mt-4" id="limitations_of_liability">
            20. LIMITATIONS OF LIABILITY
          </h4>
          <p className="lead mt-4">
            IN NO EVENT WILL WE OR OUR DIRECTORS, EMPLOYEES, OR AGENTS BE LIABLE
            TO YOU OR ANY THIRD PARTY FOR ANY DIRECT, INDIRECT, CONSEQUENTIAL,
            EXEMPLARY, INCIDENTAL, SPECIAL, OR PUNITIVE DAMAGES, INCLUDING LOST
            PROFIT, LOST REVENUE, LOSS OF DATA, OR OTHER DAMAGES ARISING FROM
            YOUR USE OF THE SERVICES, EVEN IF WE HAVE BEEN ADVISED OF THE
            POSSIBILITY OF SUCH DAMAGES. NOTWITHSTANDING ANYTHING TO THE
            CONTRARY CONTAINED HEREIN, OUR LIABILITY TO YOU FOR ANY CAUSE
            WHATSOEVER AND REGARDLESS OF THE FORM OF THE ACTION, WILL AT ALL
            TIMES BE LIMITED TO THE AMOUNT PAID, IF ANY, BY YOU TO US DURING THE
            three (3) mONTH PERIOD PRIOR TO ANY CAUSE OF ACTION ARISING. CERTAIN
            US STATE LAWS AND INTERNATIONAL LAWS DO NOT ALLOW LIMITATIONS ON
            IMPLIED WARRANTIES OR THE EXCLUSION OR LIMITATION OF CERTAIN
            DAMAGES. IF THESE LAWS APPLY TO YOU, SOME OR ALL OF THE ABOVE
            DISCLAIMERS OR LIMITATIONS MAY NOT APPLY TO YOU, AND YOU MAY HAVE
            ADDITIONAL RIGHTS.
          </p>
          <h4 className="mt-4" id="indemnification">
            21. INDEMNIFICATION
          </h4>
          <p className="lead mt-4">
            You agree to defend, indemnify, and hold us harmless, including our
            subsidiaries, affiliates, and all of our respective officers,
            agents, partners, and employees, from and against any loss, damage,
            liability, claim, or demand, including reasonable attorneys’ fees
            and expenses, made by any third party due to or arising out of: (1)
            use of the Services; (2) breach of these Legal Terms; (3) any breach
            of your representations and warranties set forth in these Legal
            Terms; (4) your violation of the rights of a third party, including
            but not limited to intellectual property rights; or (5) any overt
            harmful act toward any other user of the Services with whom you
            connected via the Services. Notwithstanding the foregoing, we
            reserve the right, at your expense, to assume the exclusive defence
            and control of any matter for which you are required to indemnify
            us, and you agree to cooperate, at your expense, with our defence of
            such claims. We will use reasonable efforts to notify you of any
            such claim, action, or proceeding which is subject to this
            indemnification upon becoming aware of it.
          </p>
          <h4 className="mt-4" id="user_data">
            22. USER DATA
          </h4>
          <p className="lead mt-4">
            We will maintain certain data that you transmit to the Services for
            the purpose of managing the performance of the Services, as well as
            data relating to your use of the Services. Although we perform
            regular routine backups of data, you are solely responsible for all
            data that you transmit or that relates to any activity you have
            undertaken using the Services. You agree that we shall have no
            liability to you for any loss or corruption of any such data, and
            you hereby waive any right of action against us arising from any
            such loss or corruption of such data.
          </p>
          <h4 className="mt-4" id="electronic_communications">
            23. ELECTRONIC COMMUNICATIONS, TRANSACTIONS, AND SIGNATURES
          </h4>
          <p className="lead mt-4">
            Visiting the Services, sending us emails, and completing online
            forms constitute electronic communications. You consent to receive
            electronic communications, and you agree that all agreements,
            notices, disclosures, and other communications we provide to you
            electronically, via email and on the Services, satisfy any legal
            requirement that such communication be in writing. YOU HEREBY AGREE
            TO THE USE OF ELECTRONIC SIGNATURES, CONTRACTS, ORDERS, AND OTHER
            RECORDS, AND TO ELECTRONIC DELIVERY OF NOTICES, POLICIES, AND
            RECORDS OF TRANSACTIONS INITIATED OR COMPLETED BY US OR VIA THE
            SERVICES. You hereby waive any rights or requirements under any
            statutes, regulations, rules, ordinances, or other laws in any
            jurisdiction which require an original signature or delivery or
            retention of non-electronic records, or to payments or the granting
            of credits by any means other than electronic means.
          </p>
          <h4 className="mt-4" id="california_user_and_residents">
            24. CALIFORNIA USERS AND RESIDENTS
          </h4>
          <p className="lead mt-4">
            If any complaint with us is not satisfactorily resolved, you can
            contact the Complaint Assistance Unit of the Division of Consumer
            Services of the California Department of Consumer Affairs in writing
            at 1625 North Market Blvd., Suite N 112, Sacramento, California
            95834 or by telephone at (800) 952-5210 or (916) 445-1254.
          </p>
          <h4 className="mt-4" id="miscellaneous">
            25. MISCELLANEOUS
          </h4>
          <p className="lead mt-4">
            These Legal Terms and any policies or operating rules posted by us
            on the Services or in respect to the Services constitute the entire
            agreement and understanding between you and us. Our failure to
            exercise or enforce any right or provision of these Legal Terms
            shall not operate as a waiver of such right or provision. These
            Legal Terms operate to the fullest extent permissible by law. We may
            assign any or all of our rights and obligations to others at any
            time. We shall not be responsible or liable for any loss, damage,
            delay, or failure to act caused by any cause beyond our reasonable
            control. If any provision or part of a provision of these Legal
            Terms is determined to be unlawful, void, or unenforceable, that
            provision or part of the provision is deemed severable from these
            Legal Terms and does not affect the validity and enforceability of
            any remaining provisions. There is no joint venture, partnership,
            employment or agency relationship created between you and us as a
            result of these Legal Terms or use of the Services. You agree that
            these Legal Terms will not be construed against us by virtue of
            having drafted them. You hereby waive any and all defences you may
            have based on the electronic form of these Legal Terms and the lack
            of signing by the parties hereto to execute these Legal Terms.
          </p>
          <h4 className="mt-4" id="contact_us">
            26. CONTACT US
          </h4>
          <p className="lead mt-4">
            In order to resolve a complaint regarding the Services or to receive
            further information regarding use of the Services, please contact us
            at:
            <br />
            <br />
            RacerSoft
            <br />
            India
            <br />
            racersoft@gmail.com
          </p>

          <h4 className="mt-4" id="contact_us">
            27. ADDITIONAL Terms Of Service:
          </h4>
          <p className="lead mt-4">
            Our website may use or integrate services provided by third parties,
            including but not limited to [e.g., payment processors, cloud
            hosting providers, analytics platforms, cpu/gpu providers etc.]. By
            using our site, you acknowledge that these third parties may have
            their own terms of service and privacy policies, and you agree to
            comply with them where applicable. We are not responsible for the
            availability, accuracy, or content of these third-party services,
            nor do we guarantee their performance or reliability. Your use of
            such services is at your own risk. Any issues, disputes, or losses
            arising from third-party services should be resolved directly with
            the applicable provider.
            <br />
            <br />
            <a
              href="https://www.runpod.io/legal/terms-of-service"
              rel="noreferrer"
              target="_blank"
            >
              Runpod Terms Of Service
            </a>
            <br />
            <a
              href="https://marketingplatform.google.com/about/analytics/terms/us/"
              rel="noreferrer"
              target="_blank"
            >
              Google Analytics Terms Of Service
            </a>
            <br />
            <a
              href="https://adsense.google.com/adsense/terms"
              rel="noreferrer"
              target="_blank"
            >
              Google Adsense Terms Of Service
            </a>
            <br />
            <a
              href="https://www.paypal.com/ga/legalhub/paypal/home"
              rel="noreferrer"
              target="_blank"
            >
              PayPal Terms Of Service
            </a>
          </p>
        </div>
      </div>

      {/* Footer */}
      <Footer />
    </div>
  );
}

export default TermsOfService;
